module.exports = __webpack_public_path__ + "static/media/mdi_bank.2965140a.svg";